import { Component } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChatbotMainComponent } from '../chatbot-main/chatbot-main';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-chatbot-toggle',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, ChatbotMainComponent],
  templateUrl: './chatbot-toggle.html',
  styleUrls: ['./chatbot-toggle.scss']
})
export class ChatbotToggleComponent {
  showToggle = true;
  isChatOpen = false;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // Ocultar completamente si estuviéramos en una ruta específica (opcional ahora)
      this.showToggle = !event.url.includes('/chatbot-full');
    });
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
  }

  expandChat() {
    this.isChatOpen = false;
    this.router.navigate(['/chatbot']);
  }
}
